/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_After_Heavier_TitleInputs */

const en_us2_workout_after_heavier_title = /** @type {(inputs: Workout_After_Heavier_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heavier than last time`)
};

const pt_br2_workout_after_heavier_title = /** @type {(inputs: Workout_After_Heavier_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mais carga que da última vez`)
};

const es_419_workout_after_heavier_title = /** @type {(inputs: Workout_After_Heavier_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más peso que la última vez`)
};

const pt_pt2_workout_after_heavier_title = /** @type {(inputs: Workout_After_Heavier_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mais carga do que da última vez`)
};

const fr_fr2_workout_after_heavier_title = /** @type {(inputs: Workout_After_Heavier_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus lourd que la dernière fois`)
};

const de_de2_workout_after_heavier_title = /** @type {(inputs: Workout_After_Heavier_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mehr Gewicht als letztes Mal`)
};

const it_it2_workout_after_heavier_title = /** @type {(inputs: Workout_After_Heavier_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Più carico dell'ultima volta`)
};

/**
* | output |
* | --- |
* | "Heavier than last time" |
*
* @param {Workout_After_Heavier_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_heavier_title = /** @type {((inputs?: Workout_After_Heavier_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_Heavier_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_heavier_title(inputs)
	if (locale === "es-419") return es_419_workout_after_heavier_title(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_heavier_title(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_heavier_title(inputs)
	if (locale === "de-DE") return de_de2_workout_after_heavier_title(inputs)
	if (locale === "it-IT") return it_it2_workout_after_heavier_title(inputs)
	return en_us2_workout_after_heavier_title(inputs)
});
export { workout_after_heavier_title as "workout-after.heavier_title" }